export default __webpack_public_path__ + "static/media/vip_locations_icons_shops.bfc9aa5f.svg";